import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { colors } from "../constants";
import { PREDICTION_WINDOW_MS } from "@/constants";
import GlassCard from "./GlassCard";
import TeamIcon from "@/components/TeamIcon";

// Next Match Countdown Card - updates every minute
const NextMatchCard = ({ match }) => {
  const [countdown, setCountdown] = useState("");

  useEffect(() => {
    const update = () => {
      const matchDate = new Date(match.match_date || match.date);
      const predictionsOpen = new Date(matchDate.getTime() - PREDICTION_WINDOW_MS);
      const now = new Date();
      const diffMs = predictionsOpen - now;
      if (diffMs <= 0) {
        setCountdown("Predictions Open");
        return;
      }
      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      if (days > 0) {
        setCountdown(`${days}d ${hours}h ${minutes}m`);
      } else {
        setCountdown(`${hours}h ${minutes}m`);
      }
    };
    update();
    const interval = setInterval(update, 60000);
    return () => clearInterval(interval);
  }, [match]);

  const getCity = (venue) => {
    const parts = (venue || "").split(",");
    return parts.length > 1 ? parts[parts.length - 1].trim() : parts[0].trim();
  };

  const matchDate = new Date(match.match_date || match.date);

  return (
    <GlassCard padding="p-[22px]">
      <div className="text-center">
        <p className="text-xs uppercase tracking-wide mb-4" style={{ color: colors.textMuted }}>
          Next Match
        </p>
        <div className="flex items-center justify-center gap-2 sm:gap-4 mb-5 overflow-hidden">
          <div className="flex items-center gap-1.5 min-w-0">
            <TeamIcon team={match.team_a} size="sm" />
            <span className="text-white font-medium text-sm sm:text-base truncate">
              {match.team_a}
            </span>
          </div>
          <span className="text-xs flex-shrink-0" style={{ color: colors.textMuted }}>
            VS
          </span>
          <div className="flex items-center gap-1.5 min-w-0">
            <span className="text-white font-medium text-sm sm:text-base truncate">
              {match.team_b}
            </span>
            <TeamIcon team={match.team_b} size="sm" />
          </div>
        </div>
        <div className="flex items-center justify-center gap-1.5 mb-2">
          <MapPin className="w-3 h-3" style={{ color: colors.textMuted }} />
          <span className="text-xs" style={{ color: colors.textMuted }}>
            {getCity(match.venue)}
          </span>
        </div>
        <div className="mt-4 pt-4 border-t border-white/10">
          <p className="text-2xl sm:text-3xl font-bold text-white mb-1">{countdown}</p>
          <p className="text-xs" style={{ color: colors.textMuted }}>
            {matchDate.toLocaleDateString("en-IN", {
              weekday: "long",
              day: "numeric",
              month: "short",
            })}{" "}
            at{" "}
            {matchDate.toLocaleTimeString("en-IN", {
              hour: "numeric",
              minute: "2-digit",
              hour12: true,
            })}
          </p>
        </div>
      </div>
    </GlassCard>
  );
};

export default NextMatchCard;
